import { useMemo } from 'react'

import { Button, Dropdown, MenuProps } from 'antd'
import { useTheme } from 'antd-style'

import { switchMemberApi } from '@eastcoal/api/auth/auth/switchMember'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { NullIcon } from '@eastcoal/icon/NullIcon'
import { DeviceType } from '@eastcoal/shared/enums/DeviceType'

export const SwitchMemberButton = () => {
  const { member, members, reload } = useAuthStore(state =>
    pick(state, ['members', 'member', 'reload'])
  )

  const items = useMemo(
    () =>
      members.map(item => ({
        key: item.memberId,
        label: item.memberName,
        disabled: member.id === item.memberId,
        async onClick() {
          await switchMemberApi({
            profileId: item.profileId,
            device: DeviceType.PC
          })
          await reload()
        }
      })) as MenuProps['items'],
    [members, member, reload]
  )

  const theme = useTheme()

  return (
    <Dropdown menu={{ items, expandIcon: <NullIcon /> }}>
      <Button
        size='small'
        type='text'
        style={{
          color: theme.orange
        }}
      >
        切换
      </Button>
    </Dropdown>
  )
}
